import { fromJS } from 'immutable'
import {
  TIMESHEET_CANCEL_REQUEST,
  TIMESHEET_CANCEL_SUCCESS,
  TIMESHEET_CANCEL_FAILURE,
  TIMESHEET_CANCEL_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_CANCEL_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_CANCEL_SUCCESS:
      return state
        .set('canceledTimesheet', fromJS(action.payload.canceledTimesheet))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', 'Successfully.')
    case TIMESHEET_CANCEL_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('canceledTimesheet', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case TIMESHEET_CANCEL_RESET:
      return state
        .delete('canceledTimesheet')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-cancel-reducer.js